// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d12d1e97","reverse":"_50d5aa24","border":"_e60c46c8","termsLink":"_71b68819"};